import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateProductCategoryMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateCoreProductCategoryInput;
}>;

export type UpdateProductCategoryMutationResult = { __typename?: 'Mutation' } & {
  updateCoreProductCategory: { __typename?: 'UpdateCoreProductCategoryPayload' } & {
    coreProductCategory?: GraphQLTypes.Maybe<
      { __typename?: 'CoreProductCategory' } & Pick<GraphQLTypes.CoreProductCategory, 'id' | 'name'>
    >;
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateProductCategoryDocument = gql`
  mutation updateProductCategory($input: UpdateCoreProductCategoryInput!) {
    updateCoreProductCategory(input: $input) {
      coreProductCategory {
        id
        name
      }
      errors {
        message
        path
      }
    }
  }
`;
